<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="分类名称">
                <el-input style="width: 177px" v-model="queryForm.categoryName"></el-input>
            </el-form-item>
            <el-form-item label="上级分类">
<!--                <el-input v-model="queryForm.parentId"></el-input>-->
                <el-select
                    style="width: 177px"
                    v-model="queryForm.parentId"
                    placeholder="请选择分类名称"
                    clearable
                    size="small"
                >
                    <el-tree default-expand-all :data="cmsAdsCategoryList"
                             :props="{ children: 'children', label: 'folderName' }">
                        <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                            <el-option :label="data.categoryName" :value="data.id"></el-option>
                        </div>
                    </el-tree>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getCmsAdsCategoryList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addCmsAdsCategory"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editCmsAdsCategory(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteCmsAdsCategory(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--                    <span-->
<!--                        title="下载模板"-->
<!--                        class="icon-box"-->
<!--                        @click="importTemplate"-->
<!--                    >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--                    <span-->
<!--                        class="icon-box"-->
<!--                        title="导入数据"-->
<!--                        @click="isImport"-->
<!--                    >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--                    <span-->
<!--                        title="导出数据"-->
<!--                        class="icon-box"-->
<!--                        @click="exportCmsAdsCategoryList"-->
<!--                    >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
                    <span
                        class="icon-box"
                        @click="refreshCmsAdsCategoryList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="cmsAdsCategoryList"
                row-key="id"
                border
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                default-expand-all
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    prop="categoryName"
                    label="分类名称"
                    min-width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="id"
                    label="分类id"
                    min-width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="categoryPic"
                    label="分类图片"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.categoryPic'>
                            <el-image
                                @click='updateSrcList(scope.row.categoryPic)'
                                style="width: 30px; height: 30px"
                                :src="scope.row.categoryPic"
                                :preview-src-list="srcList"
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="sort"
                    label="排序"
                    min-width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    min-width="180"
                ></el-table-column>
                <!-- <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  prop="parentId"
                  label="分类"
                  min-width="180"
                >
                  <template slot-scope="scope">
                    {{ selectres(scope.row.parentId) }}
                  </template>
                </el-table-column> -->
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    min-width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkCmsAdsCategory(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editCmsAdsCategory(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteCmsAdsCategory(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="pagination-box">
              <el-pagination
                @size-change="sizeChange"
                @current-change="currentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                background
                :pager-count="7"
              >
              </el-pagination>
            </div> -->
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="cmsAdsCategoryStates[cmsAdsCategoryState]"
                :visible.sync="showDialog"
                width="400px"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="cmsAdsCategory"
                        ref="cmsAdsCategoryForm"
                        :rules="rules"
                        label-width="100px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="分类名称"
                            prop="categoryName"
                        >
                            <el-input
                                style="width: 200px"
                                size="small"
                                v-model="cmsAdsCategory.categoryName"
                                :disabled="cmsAdsCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="图片宽度"
                            prop="width"
                        >
                            <el-input
                                style="width: 200px"
                                size="small"
                                v-model="cmsAdsCategory.width"
                                :disabled="cmsAdsCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="图片高度"
                            prop="height"
                        >
                            <el-input
                                style="width: 200px"
                                size="small"
                                v-model="cmsAdsCategory.height"
                                :disabled="cmsAdsCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="分类图片"
                            prop="categoryPic"
                        >
                            <!-- <el-input
                              size="small"
                              style="width: 200px"
                              v-model="cmsAdsCategory.categoryPic"
                              :disabled="cmsAdsCategoryState == 'check'"
                            ></el-input> -->
                            <el-upload
                                :disabled="cmsAdsCategoryState == 'check'"
                                style="width: 200px"
                                class="avatar-uploader"
                                action=""
                                :show-file-list="false"
                                :http-request="uploadAvatar">
                                <img v-if="cmsAdsCategory.categoryPic" :src="cmsAdsCategory.categoryPic" class="avatar"
                                     size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="上级分类"
                            prop="parentId"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="cmsAdsCategory.parentId"
                              :disabled="cmsAdsCategoryState == 'check'"
                            ></el-input> -->
                            <el-select
                                style="width: 200px"
                                v-model="cmsAdsCategory.parentId"
                                placeholder="请选择分类名称"
                                :disabled="cmsAdsCategoryState == 'check'"
                                clearable
                                size="small"
                            >
                                <el-tree default-expand-all :data="cmsAdsCategoryList"
                                         :props="{ children: 'children', label: 'folderName' }">
                                    <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                        <el-option :label="data.categoryName" :value="data.id"></el-option>
                                    </div>
                                </el-tree>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="排序"
                            prop="sort"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="cmsAdsCategory.sort"
                                :disabled="cmsAdsCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="cmsAdsCategoryState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetCmsAdsCategoryList();
                this.getCmsAdsCategoryList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetCmsAdsCategoryList();
                this.getCmsAdsCategoryList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                categoryName: '', //分类名称
                categoryPic: '', //分类图片
                parentId: '', //父ID
                sort: '' //排序
            },
            // mppFileFolderList:[],
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            cmsAdsCategoryState: 'add',
            cmsAdsCategoryStates: {
                add: '新建分类',
                check: '查看分类',
                edit: '修改分类'
            },
            srcList: [''],
            multipleSelection: [],
            cmsAdsCategoryList: [],
            cmsAdsCategory: {
                categoryName: '', //分类名称
                categoryPic: '', //分类图片
                parentId: '', //父ID
                sort: '', //排序
                width: '', //图片宽度
                height: '' //图片高度
            },
            btnLoading: false,

            rules: {
                categoryName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
                // categoryPic: [{ required: true, message: '分类图片不能为空', trigger: 'blur' }],
                // parentId: [{ required: true, message: '父ID不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
                // width: [{ required: true, message: '图片宽度不能为空', trigger: 'blur' }],
                // height: [{ required: true, message: '图片高度不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getCmsAdsCategoryList();
        // this.getMppFileFolderList();
    },
    methods: {
        updateSrcList(src) {
            this.srcList[0] = src;
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.cmsAdsCategory.categoryPic = res.url;
                }
            });
        },
        // getMppFileFolderList() {
        //   this.loading = true;
        //   get(`cms/adscategory/findAllAsTree`).then((res) => {
        //     this.loading = false;
        //     if (res.success) {
        //       this.mppFileFolderList = res.treeData;
        //       console.log(this.mppFileFolderList);
        //       // this.totalNum = res.page.total;
        //     } else {
        //       this.$message({
        //         message: res.msg,
        //         type: 'error',
        //         duration: 2000
        //       });
        //     }
        //   });
        // },
        selectres(id) {
            for (const iterator of this.mppFileFolderList) {
                if (id == iterator.id) {
                    return iterator.categoryName;
                }
            }
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetCmsAdsCategoryList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.cmsAdsCategoryList = [];
        },
        resetDialog() {
            this.cmsAdsCategoryState = 'add';
            this.showDialog = false;
            this.queryForm = {
                categoryName: '', //分类名称
                categoryPic: '', //分类图片
                parentId: '', //父ID
                sort: '' //排序
            };
            this.getCmsAdsCategoryList();
        },
        closeDialog() {
            this.showDialog = false;
            this.cmsAdsCategory = {
                categoryName: '', //分类名称
                categoryPic: '', //分类图片
                parentId: '', //父ID
                sort: '' //排序
            };
        },
        submitForm() {
            if (this.cmsAdsCategoryState == 'add') {
                this.$refs.cmsAdsCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/cms/adscategory/add`, { ...this.cmsAdsCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetCmsAdsCategoryList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.cmsAdsCategoryState == 'edit') {
                this.$refs.cmsAdsCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/cms/adscategory/edit`, { ...this.cmsAdsCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetCmsAdsCategoryList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addCmsAdsCategory() {
            this.showDialog = true;
            this.cmsAdsCategoryState = 'add';
        },
        checkCmsAdsCategory(cmsAdsCategoryId) {
            console.log(cmsAdsCategoryId);
            this.currentCmsAdsCategoryId = cmsAdsCategoryId;

            this.getCmsAdsCategoryById();
            this.showDialog = true;
            this.cmsAdsCategoryState = 'check';
        },
        editCmsAdsCategory(cmsAdsCategoryId) {
            console.log('cmsAdsCategory', cmsAdsCategoryId);
            if (cmsAdsCategoryId) {
                this.currentCmsAdsCategoryId = cmsAdsCategoryId;
                this.getCmsAdsCategoryById();
            } else {
                this.cmsAdsCategory = { ...this.cmsAdsCategory, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.cmsAdsCategoryState = 'edit';
        },
        deleteCmsAdsCategory(cmsAdsCategoryId) {
            let ids = '';
            if (cmsAdsCategoryId) {
                ids = cmsAdsCategoryId;
            } else {
                ids = this.multipleSelection.map((cmsAdsCategory) => cmsAdsCategory.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/cms/adscategory/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetCmsAdsCategoryList();
                            this.getCmsAdsCategoryList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshCmsAdsCategoryList() {
            this.resetCmsAdsCategoryList();
            this.getCmsAdsCategoryList();
        },
        getCmsAdsCategoryList(query = {}) {
            this.loading = true;
            get(`/cms/adscategory/findAllAsTree`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.cmsAdsCategoryList = res.treeData;
                    // this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getCmsAdsCategoryById() {
            get(`/cms/adscategory/get`, { id: this.currentCmsAdsCategoryId }).then((res) => {
                if (res.success) {
                    this.cmsAdsCategory = { ...this.cmsAdsCategory, ...res.cmsAdsCategory };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportCmsAdsCategoryList() {
            //this.btnLoading = true;
            exprotExcel(`/cms/adscategory/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/cms/adscategory/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/cms/adscategory/importData`, formData);
            this.refreshCmsAdsCategoryList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getCmsAdsCategoryList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getCmsAdsCategoryList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
</style>